export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    track({ commit, state, dispatch, rootState }, { verb, object_id, object_type, referrer, target }) {
      const payload = {
        events: {
          verb,
          object_id,
          object_type,
          referrer,
          target,
        },
      };
      if (rootState.auth.loggedin) {
        payload.user_id = rootState.auth.user_id;
        payload.user_name = rootState.auth.user_name;
      }
      this._vm.$MS_ANALYTICS_API_URL
        .post(`/sessions/me`, payload)
        .then((response) => {
          if (response.status === 200) {
            // console.log(response)
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
